/** See `src/i18n/locales/en/editions.ts`. */
export const editions = {
  fit: {
    sections: {
      home: 'Start',
      insights: 'Inzichten',
      programs: "Programma's",
      content: 'Content',
    },
    items: {
      overview: 'Overzicht',
      departments: 'Afdelingen',
      users: 'Medewerkers',
      vitality: 'Vitaliteit',
      participation: 'Deelname',
      pilots: 'Pilot',
      challenges: 'Challenges',
      communications: 'Communicatie',
      documents: 'Documenten',
      reports: 'Rapportages',
      settings: 'Instellingen',
    },
  },
  soccer: {
    sections: {
      home: 'Start',
      insights: 'Inzichten',
      programs: "Programma's",
    },
    items: {
      overview: 'Overzicht',
      departments: 'Teams',
      users: 'Spelers',
      vitality: 'Vitaliteit',
      participation: 'Deelname',
      pilots: 'Pilots',
      challenges: 'Challenges',
    },
  },
} as const;
